import { Inline, Text } from '@etg/wings';
import type { CabinBaggageTripSummary } from '@eti/schema-types';
import { useProperty, useTranslation } from '@eti/providers';
import { XCircle } from '@phosphor-icons/react';
import { css } from '@eti/styles';
import useGetPersonalAndCabinBaggageInfo from './hooks/useGetPersonalAndCabinBaggageInfo';
import CabinBaggageNotIncludedFeature from './CabinBaggageNotIncludedFeature';
import { iconStyles } from './CabinBaggageFeature';

const featureTextStyles = css`
  color: #737373;
  width: -webkit-fill-available; /* stylelint-disable */
`;

interface PersonalItemAndCabinBaggageNotIncludedFeatureProps {
  isPersonalItemIncluded: boolean;
  cabinBaggageTripSummary: CabinBaggageTripSummary;
  showNotIncludedProducts: boolean;
}

const PersonalItemAndCabinBaggageNotIncludedFeature = ({
  isPersonalItemIncluded,
  cabinBaggageTripSummary,
  showNotIncludedProducts,
}: PersonalItemAndCabinBaggageNotIncludedFeatureProps) => {
  const { t } = useTranslation();
  const { p } = useProperty();
  const { isIncluded, personalAndCabinText } = useGetPersonalAndCabinBaggageInfo(
    isPersonalItemIncluded,
    cabinBaggageTripSummary,
  );
  const personalAndCabinBaggageShowType = String(
    p('BrandedFares.PersonalAndCabinBaggage.ShowType'),
  ).toUpperCase();
  const personalAndCabinBaggageDefaultShowType = 'SEPARATE';
  const personalAndCabinBaggageShowTypePair = 'PAIR';
  if (personalAndCabinBaggageShowType === personalAndCabinBaggageDefaultShowType) {
    const personalItemText =
      !isPersonalItemIncluded && t('BrandedFares.PersonalBaggageNotIncluded.Text');
    const cabinBaggageFeature = (
      <CabinBaggageNotIncludedFeature
        cabinBaggageTripSummary={cabinBaggageTripSummary}
        showNotIncludedProducts={showNotIncludedProducts}
      />
    );
    return (
      <>
        {!isPersonalItemIncluded && (
          <Inline as="li" noWrap role="listitem" spacing={8}>
            <XCircle className={iconStyles} color="#737373" size={20} weight="thin" />
            <Text as="p" className={featureTextStyles}>
              {personalItemText}
            </Text>
          </Inline>
        )}
        {cabinBaggageFeature}
      </>
    );
  }
  if (personalAndCabinBaggageShowType === personalAndCabinBaggageShowTypePair) {
    return (
      <>
        {!isIncluded && (
          <Inline as="li" noWrap role="listitem" spacing={8}>
            <XCircle className={iconStyles} color="#737373" size={20} weight="thin" />
            <Text as="p" className={featureTextStyles}>
              {personalAndCabinText}
            </Text>
          </Inline>
        )}
      </>
    );
  }
  return null;
};

export default PersonalItemAndCabinBaggageNotIncludedFeature;
